export default "__VITE_ASSET__okx1rHy___"